import { sum } from 'lodash-es';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext';
import { DividerLine, Switch } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import {
  Listing,
  ListingGroupAutoPriceSettings,
  ListingStatus,
} from 'src/WebApiController';

import { StatLabel } from '../../../Map/StatLabel';
import * as styles from './PricingSetting.css';

export const PricingSettingGroupHeader = ({
  groupName,
  flattenedListingGroup,
}: {
  groupName: string;
  flattenedListingGroup: Listing[] | undefined;
}) => {
  const { watch, setValue } = useFormContext<ListingGroupAutoPriceSettings>();
  const { autoPricingEnabled } = watch();

  const soldQty = useMemo(() => {
    return sum(
      flattenedListingGroup?.filter((l) => !l.isLtGrp).map((l) => l.soldQty)
    );
  }, [flattenedListingGroup]);

  const listedQty = useMemo(() => {
    return sum(
      flattenedListingGroup
        ?.filter(
          (l) =>
            !l.isLtGrp &&
            ((l as Listing).status === ListingStatus.Listed ||
              (l as Listing).status === ListingStatus.ListingPending)
        )
        .map((l) => l.availQty)
    );
  }, [flattenedListingGroup]);

  const queuedQty = useMemo(() => {
    return sum(
      flattenedListingGroup
        ?.filter(
          (l) =>
            !l.isLtGrp &&
            !(
              (l as Listing).status === ListingStatus.Listed ||
              (l as Listing).status === ListingStatus.ListingPending
            )
        )
        .map((l) => l.availQty)
    );
  }, [flattenedListingGroup]);

  return (
    <div className={styles.container}>
      <StatLabel
        stat={groupName ?? ''}
        title={<Content id={ContentId.Group} />}
      />
      <DividerLine vertical height={'100%'} />
      <StatLabel stat={`${soldQty}`} title={<Content id={ContentId.Sold} />} />
      <DividerLine vertical height={'100%'} />
      <StatLabel
        stat={`${listedQty}`}
        title={<Content id={ContentId.Listed} />}
      />
      <DividerLine vertical height={'100%'} />
      <StatLabel
        stat={`${queuedQty}`}
        title={<Content id={ContentId.Queued} />}
      />
      <DividerLine vertical height={'100%'} />
      <Switch
        checked={autoPricingEnabled ?? false}
        onClick={(e) => e.stopPropagation()}
        onCheckedChange={(isChecked) => {
          const checked = isChecked;
          setValue('autoPricingEnabled', checked);
        }}
      />
    </div>
  );
};
